import { appActions } from './actions';
import { appMutations } from './mutations';
import { appGetters } from './getters';

const state = {
  sidebarStatus: true,
  loading: 0,
  appTitle: "Heliocity",
  constants: {},
  lang_code: 'all'
};
const actions = { ...appActions };
const mutations = { ...appMutations };
const getters = { ...appGetters };


// eslint-disable-next-line import/prefer-default-export
export const appStore = {
  state, actions, mutations, getters,
};
